// extracted by mini-css-extract-plugin
export default {"item":"item---tqNqW","content":"content---_liQ4","creationLabel":"creationLabel---fblqP"};